var obsAprovador = document.getElementById('obs-aprovador');
var obsAprovadorQtd = document.getElementById('obs-aprovador-qtd');
var obsAprovadorVlr = document.getElementById('obs-aprovador-vlr');
var modalWorkflowReprovacao = $('#modal-workflow-reprovacao');

function genericWorkflowMessage(aprovou) {
  return 'Não foi possível realizar a '
    + (aprovou ? 'aprovação' : 'reprovação')
    + ' no momento, tente novamente. Se erro persistir entrar em contato com o suporte (b.link.suporte@bild.com.br).'

}

function showModalReprovacao(selector) {
  if (selector) {
    modalWorkflowReprovacao = $(selector);
  } else {
    modalWorkflowReprovacao = $('#modal-workflow-reprovacao');
  }

  modalWorkflowReprovacao.modal('show');
}

// Chama modal de reprovação em massa
function showModalReprovacaoTodos(selector) {
  if(selector) {
    modalWorkflowReprovacao = $(selector);
    modalWorkflowReprovacao.modal('show');
  }


}

// call this before showing SweetAlert:
function fixBootstrapModal() {
  var modalNode = document.querySelector('.modal[tabindex="-1"]');
  if (!modalNode) return;

  modalNode.removeAttribute('tabindex');
  modalNode.classList.add('js-swal-fixed');
}

// call this before hiding SweetAlert (inside done callback):
function restoreBootstrapModal() {
  var modalNode = document.querySelector('.modal.js-swal-fixed');
  if (!modalNode) return;

  modalNode.setAttribute('tabindex', '-1');
  modalNode.classList.remove('js-swal-fixed');
}

// Observação Aprovador - Uso Geral
if (obsAprovador) {
  var key = obsAprovador.dataset.key;

  obsAprovador.value = localStorage.getItem(key);

  var saveObs = _.debounce(function (event) {
    localStorage.setItem(key, obsAprovador.value);
  }, 700);

  obsAprovador.addEventListener('input', saveObs);
  obsAprovador.addEventListener('change', saveObs);
}

// Observação Aprovador - Reajuste de Quantidade
if (obsAprovadorQtd) {
  var key = obsAprovadorQtd.dataset.key;

  obsAprovadorQtd.value = localStorage.getItem(key);

  var saveObs = _.debounce(function(event) {
    localStorage.setItem(key, obsAprovadorQtd.value);
  }, 700);

  obsAprovadorQtd.addEventListener('input', saveObs);
  obsAprovadorQtd.addEventListener('change', saveObs);
}

// Observação Aprovador - Reajuste de Valor
if (obsAprovadorVlr) {
  var key = obsAprovadorVlr.dataset.key;

  obsAprovadorVlr.value = localStorage.getItem(key);

  var saveObs = _.debounce(function(event) {
    localStorage.setItem(key, obsAprovadorVlr.value);
  }, 700);

  obsAprovadorVlr.addEventListener('input', saveObs);
  obsAprovadorVlr.addEventListener('change', saveObs);
}


function workflowCall(item_id, tipo_item, aprovou, elemento, motivo, justificativa_texto, pai_id, pai_obj, filhos_metodo, shouldReload, callback) {
  var url_aprova_reprova = '/workflow/aprova-reprova';

  if (pai_id > 0) {
    url_aprova_reprova = '/workflow/aprova-reprova-tudo'
  }

  var data = {
    id: item_id,
    tipo: tipo_item,
    resposta: aprovou,
    motivo_id: motivo,
    justificativa: justificativa_texto,
    pai: pai_id,
    pai_tipo: pai_obj,
    filhos_relacionamento: filhos_metodo
  };

  var obsAprovador = document.getElementById('obs-aprovador');
  var obsAprovadorQtd = document.getElementById('obs-aprovador-qtd');
  var obsAprovadorVlr = document.getElementById('obs-aprovador-vlr');

  // Remoção de Observação Geral
  if (obsAprovador && aprovou) {
    var key = obsAprovador.dataset.key;

    localStorage.removeItem(key);
    data.justificativa = obsAprovador.value;
  }

  // Remoção de Observação Reajuste de Quantidade
  if (obsAprovadorQtd && aprovou && data.tipo === 'ContratoItemModificacao') {
    var key = obsAprovadorQtd.dataset.key;

    localStorage.removeItem(key);
    data.justificativa = obsAprovadorQtd.value;
  }

  // Remoção de Observação Reajuste de Valor
  if (obsAprovadorVlr && aprovou && data.tipo === 'ContratoItemModificacaoValor') {
    var key = obsAprovadorVlr.dataset.key;

    localStorage.removeItem(key);
    data.justificativa = obsAprovadorVlr.value;
  }

  return $.get(url_aprova_reprova, data)
    .done(function (response) {
      if (response.success) {

        if (aprovou) {
          titulo = 'Aprovado';
          conteudoElemento = '<span class="btn-lg btn-flat text-success" title="Aprovado por você">' +
            '<i class="fa fa-check" aria-hidden="true"></i>' +
            '</span>';
        } else {
          titulo = 'Reprovado';
          conteudoElemento = '<span class="text-danger btn-lg btn-flat" title="Reprovado por você">' +
            '<i class="fa fa-times" aria-hidden="true"></i>' +
            '</span>';
        }

        $('#' + elemento + item_id).html(conteudoElemento);

        // verifica se tem pai, e o mesmo foi afetado
        if (response.id_pai && response.alteraPai) {
          var conteudoElementoPai = '';
          if (response.tudo_aprovado) {
            conteudoElementoPai = '<span class="btn-lg btn-flat text-success" title="Aprovado por você">' +
              '<i class="fa fa-check" aria-hidden="true"></i>' +
              '</span>';
          } else {
            conteudoElementoPai = '<span class="text-danger btn-lg btn-flat" title="Reprovado por você">' +
              '<i class="fa fa-times" aria-hidden="true"></i>' +
              '</span>';
          }

          $('#' + elemento + 'Pai' + response.id_pai).html(conteudoElementoPai);
        }



        if (response.proximo) {
          swal({
              title: titulo,
              text: 'Sua escolha foi salva com sucesso, deseja ir para o próximo item com aprovação pendente?',
              type: "success",
              showCancelButton: true,
              showConfirmButton: true,
              allowOutsideClick: true,
              closeOnConfirm: true
            },
            function () {
              window.location = response.proximo;
            });
        } else {
          swal({
              title: titulo,
              text: 'Sua escolha foi salva com sucesso!',
              type: "success",
              showCancelButton: false,
              showConfirmButton: true,
              allowOutsideClick: true,
              closeOnConfirm: true
            },
            function () {
              if (pai_id > 0 || shouldReload) {
                window.location.reload();
              }

              if (response.tudo_aprovado) {
                setTimeout(function () {
                  window.location.reload();
                }, 2000);
              }

              swal.close();
            });

          if (typeof callback === "function") {
            callback();
          }

          if (response.refresh) {
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          }

        }
      } else {
        swal({
          title: aprovou ? 'Aprovação' : 'Reprovação',
          text: response.message || genericWorkflowMessage(aprovou),
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: true,
          closeOnConfirm: true
        });
      }
    })
    .fail(function(jqXHR) {
      swal({
        type: 'error',
        title: aprovou ? 'Aprovação' : 'Reprovação',
        text: genericErrorMessage(aprovou),
      })
    });
}

function workflowCallTodos(item_id, tipo_item, aprovou, elemento, motivo, justificativa_texto, pai_id, pai_obj, filhos_metodo, shouldReload, callback) {
  var url_aprova_reprova = '/workflow/aprova-reprova';

  var data = {
    id: item_id,
    tipo: tipo_item,
    resposta: aprovou,
    motivo_id: motivo,
    justificativa: justificativa_texto,
  };

  return $.get(url_aprova_reprova, data)
    .done(function(response) {

      if (response.success) {

        swal({
            title: aprovou ? 'Aprovação' : 'Reprovação',
            text: 'Sua escolha foi salva com sucesso!',
            type: "success",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: true,
            closeOnConfirm: true
          },
          function() {
            if (shouldReload) {
              window.location.reload();
            }

            swal.close();
          });

        if (typeof callback === "function") {
          callback();
        }

        if (response.refresh) {
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        }
      } else {
        swal({
          title: aprovou ? 'Aprovação' : 'Reprovação',
          text: response.message || genericWorkflowMessage(aprovou),
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: true,
          closeOnConfirm: true
        });
      }

      if (response.refresh) {
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      }
    })
    .fail(function (jqXHR) {
      swal({
        type: 'error',
        title: aprovou ? 'Aprovação' : 'Reprovação',
        text: genericErrorMessage(aprovou),
      })
    });
}

var options_motivos = '';
var canReload;

function workflowAprovaReprova(item_id, tipo_item, aprovou, elemento, nome, pai_id, pai_obj, filhos_metodo, shouldReload, callback) {
  canReload = shouldReload;
  fixBootstrapModal();
  if (!aprovou) {
    var errors = [];
    var justificativa = modalWorkflowReprovacao.find('.js-workflow-reprovacao-justificativa:first').val();
    var motivos = modalWorkflowReprovacao.find('.js-workflow-reprovacao-motivos:first').val();

    if (!justificativa) {
      errors.push('Escreva uma justificativa')
    }

    if (!motivos || (motivos && !motivos.length)) {
      errors.push('Selecione pelo menos um motivo de reprovação')
    }

    if (errors.length) {
      var errorList = new ErrorList(errors);
      return errorList.show(restoreBootstrapModal);
    }

    modalWorkflowReprovacao.modal('hide');
    swal({
      type: 'warning',
      title: "Reprovar " + nome + "?",
      text: "Ao confirmar não será possível voltar atrás",
      showCancelButton: true,
      closeOnConfirm: false,
      animation: "slide-from-top",
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Reprovar',
      confirmButtonColor: '#DD6B55'
    }, function () {
      workflowCall(item_id, tipo_item, aprovou, elemento, motivos, justificativa, pai_id, pai_obj, filhos_metodo, shouldReload, callback)
      restoreBootstrapModal();
    });
  } else {
    swal({
      title: "Aprovar " + nome + "?",
      text: "Ao confirmar não será possível voltar atrás",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Aprovar",
      cancelButtonText: 'Cancelar',
      closeOnConfirm: false,
      confirmButtonColor: '#7ED32C',
      showLoaderOnConfirm: true,
    }, function () {
      workflowCall(item_id, tipo_item, aprovou, elemento, null, null, pai_id, pai_obj, filhos_metodo, shouldReload);
      restoreBootstrapModal();
    });
  }
}

// Workflow para aprovação / reprovação em massa
function WorkflowAprovaReprovaTodos(item_id, tipo_item, aprovou, elemento, nome, pai_id, pai_obj, filhos_metodo, shouldReload, callback) {
  canReload = shouldReload;
  fixBootstrapModal();
  if (!aprovou) {
    var errors = [];
    var justificativa = modalWorkflowReprovacao.find('.js-workflow-reprovacao-justificativa:first').val();
    var motivos = modalWorkflowReprovacao.find('.js-workflow-reprovacao-motivos:first').val();

    if(!justificativa) {
      errors.push('Escreva uma justificativa')
    }

    if(!motivos || (motivos && !motivos.length)) {
      errors.push('Selecione pelo menos um motivo de reprovação')
    }

    if(errors.length) {
      var errorList = new ErrorList(errors);
      return errorList.show(restoreBootstrapModal);
    }

    modalWorkflowReprovacao.modal('hide');

    swal({
      type: 'warning',
      title: "Reprovar Todos " + nome + "?",
      text: "Ao confirmar não será possível voltar atrás",
      showCancelButton: true,
      closeOnConfirm: false,
      animation: "slide-from-top",
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Reprovar',
      confirmButtonColor: '#DD6B55'
    }, function() {
      workflowCallTodos(item_id, tipo_item, aprovou, elemento, motivos, justificativa, pai_id, pai_obj, filhos_metodo, shouldReload, callback)
      restoreBootstrapModal();
    });
  } else {
    swal({
      title: "Aprovar Todos " + nome + "?",
      text: "Ao confirmar não será possível voltar atrás",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Aprovar",
      cancelButtonText: 'Cancelar',
      closeOnConfirm: false,
      confirmButtonColor: '#7ED32C',
      showLoaderOnConfirm: true,
    }, function() {
      workflowCallTodos(item_id, tipo_item, aprovou, elemento, null, null, pai_id, pai_obj, filhos_metodo, shouldReload);
      restoreBootstrapModal();
    });
  }
}


$(function () {
  $(document).on('click', '.sweet-overlay', function () {
    if (canReload === true) {
      window.location.reload();
    }
  });
})

// Função para validar se será possível aprovar a alçada atual do QC
// Verifica se está na última alçada e se existe comprador na carteira
function validarAprovacaoQc(item_id, tipo_item, aprovou, elemento, nome, pai_id, pai_obj, filhos_metodo, shouldReload) {
  if ($('#ultima_alcada').val() === '1') {
    if ($('#comprador_id').val() === null) {
      swal({
        type: "warning",
        title: "Atenção!",
        text: "Selecione um comprador da carteira para prosseguir com a aprovação.",
        confirmButtonText: "Entendi!",
        confirmButtonColor: '#7ED32C',
        showCancelButton: false
      });
      return;
    }
  }


  workflowAprovaReprova(item_id, tipo_item, aprovou, elemento, nome, pai_id, pai_obj, filhos_metodo, shouldReload, salvarComprador());

  return;
}

function salvarComprador() {
  $.post($('#form-qc-show').attr('action'), $('#form-qc-show').serialize())
}
